<template>
    <div>
        <w-app
            :title="$t('module.workers_tools')"
            show-total
            :total="workers.length"
        >
            <template v-slot:leftToolbar>
                <ImportModel file-name="Employe.xlsx"/>
            </template>
            <template v-slot:rightToolbar>
                <w-btn
                    color="teal"
                    icon="mdi-import"
                    :text="$t('common.import')"
                    @press="dialog = true"
                />
                <w-btn
                    color="orange"
                    icon="mdi-skull-scan"
                    :text="$t('common.logs')"
                    @press="logDialog = true"
                />
                <w-btn
                    v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                    color="red"
                    icon="mdi-table-check"
                    :text="$t('common.apply')"
                    :loading="loading"
                    @press="applyDialog = true"
                />

            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"/>
                        </v-col>
                    </v-row>
                </v-container>
                <v-skeleton-loader
                    v-show="loading"
                    ref="skeleton"
                    :type="'table'"
                    :class="`mx-auto elevation-${tableElevation}`"
                ></v-skeleton-loader>
                <v-data-table
                    v-show="!loading"
                    :headers="headers"
                    :search="search"
                    :items="workers"
                    :loading="loading"
                    dense
                    :class="`elevation-${tableElevation}`"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :item-class="rowColor"
                    @click:row="itemClick"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip color="teal" :text="item.code"/>
                    </template>
                    <template v-slot:[`item.stateName`]="{ item }">
                        <w-chip outlined :text="item.stateName"/>
                    </template>
                    <template v-slot:[`item.lastName`]="{ item }">
                        <w-chip outlined :text="item.lastName"/>
                    </template>
                    <template v-slot:[`item.firstName`]="{ item }">
                        <w-chip outlined :text="item.firstName"/>
                    </template>
                    <template v-slot:[`item.birthDay`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.birthDay)"/>
                    </template>
                    <template v-slot:[`item.birthPlace`]="{ item }">
                        <w-chip outlined :text="item.birthPlace"/>
                    </template>
                    <template v-slot:[`item.sex`]="{ item }">
                        <w-chip v-if="item.sex" outlined :text="$t(`worker.sex.${item.sex}`)"/>
                    </template>
                    <template v-slot:[`item.familySituationName`]="{ item }">
                        <w-chip outlined :text="item.familySituationName"/>
                    </template>
                    <template v-slot:[`item.weddingDate`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.weddingDate)"/>
                    </template>
                    <template v-slot:[`item.personalPhone`]="{ item }">
                        <w-chip outlined :text="item.personalPhone"/>
                    </template>
                    <template v-slot:[`item.professionalPhone`]="{ item }">
                        <w-chip outlined :text="item.professionalPhone"/>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <w-chip outlined :text="item.email"/>
                    </template>
                    <template v-slot:[`item.occupationName`]="{ item }">
                        <w-chip outlined :text="item.occupationName"/>
                    </template>
                    <template v-slot:[`item.organizationalChartName`]="{ item }">
                        <w-chip outlined :text="item.organizationalChartName"/>
                    </template>
                    <template v-slot:[`item.responsibleName`]="{ item }">
                        <w-chip outlined :text="item.responsibleName"/>
                    </template>
                    <template v-slot:[`item.realEnterDate`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.realEnterDate)"/>
                    </template>
                    <template v-slot:[`item.companyName`]="{ item }">
                        <w-chip outlined :text="item.companyName"/>
                    </template>
                    <template v-slot:[`item.workplaceName`]="{ item }">
                        <w-chip outlined :text="item.workplaceName"/>
                    </template>
                    <template v-slot:[`item.exitDate`]="{ item }">
                        <w-chip outlined :text="formatedDate(item.exitDate)"/>
                    </template>
                    <template v-slot:[`item.leavingCauseName`]="{ item }">
                        <w-chip outlined :text="item.leavingCauseName"/>
                    </template>
                    <template v-slot:[`item.cnasAgencyName`]="{ item }">
                        <w-chip outlined :text="item.cnasAgencyName"/>
                    </template>
                    <template v-slot:[`item.nss`]="{ item }">
                        <w-chip outlined :text="item.nss"/>
                    </template>
                    <template v-slot:[`item.numMutuelle`]="{ item }">
                        <w-chip outlined :text="item.numMutuelle"/>
                    </template>
                    <template v-slot:[`item.carteShifaNumber`]="{ item }">
                        <w-chip outlined :text="item.carteShifaNumber"/>
                    </template>
                    <template v-slot:[`item.numCompte`]="{ item }">
                        <w-chip outlined :text="item.numCompte"/>
                    </template>
                    <template v-slot:[`item.numCcp`]="{ item }">
                        <w-chip outlined :text="item.numCcp"/>
                    </template>
                    <template v-slot:[`item.prenomPere`]="{ item }">
                        <w-chip outlined :text="item.prenomPere"/>
                    </template>
                    <template v-slot:[`item.nomMere`]="{ item }">
                        <w-chip outlined :text="item.nomMere"/>
                    </template>
                    <template v-slot:[`item.prenomMere`]="{ item }">
                        <w-chip outlined :text="item.prenomMere"/>
                    </template>
                    <template v-slot:footer="{}">
                        <br/>
                        <div class="text-center">
                            <v-row justify="center">
                                <v-col md="6">
                                    <v-pagination
                                        v-model="page"
                                        :length="pageCount"
                                    ></v-pagination>
                                </v-col>
                                <v-col md="2">
                                    <v-select
                                        v-model="itemsPerPage"
                                        :items="paginationListLength"
                                        :label="$t('common.items_per_page')"
                                        outlined
                                        dense
                                        :color="inputColor"
                                        :background-color="backgroundColor"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-data-table>
            </template>
        </w-app>

        <v-dialog
            v-model="dialog"
            persistent
            max-width="700"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.import')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <strong>{{ $t('common.file') }} *</strong>
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="autoOrganizationalChart"
                                    label="Organigramme par défaut"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="autoResponsible"
                                    label="Responsable hiérarchique par défaut"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn-import :loading="loading" @press="upload"/>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="logDialog"
            max-width="600"
            scrollable
        >
            <v-card>
                <w-toolbar color="orange" title="Logs"/>
                <v-card-text>
                    <v-container fluid>
                        <v-list dense>
                            <v-list-item
                                v-for="(log, index) in logs"
                                :key="`log-${index}`"
                            >
                                <v-list-item-title>{{ log }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="applyDialog"
            persistent
            max-width="600"
        >
            <v-card>
                <w-toolbar flat color="red" title="Appliquer"/>
                <v-card-text>
                    <v-container fluid>
                        <v-radio-group row v-model="updateOption">
                            <v-radio :value="false" label="Initialisation"/>
                            <v-radio :value="true" label="MAJ"/>
                        </v-radio-group>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="applyDialog = false"/>
                    <w-btn
                        color="red"
                        icon="mdi-table-check"
                        :text="$t('common.apply')"
                        :loading="applyLoading"
                        @press="apply"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {ref} from "vue";
import useTools from "@/use/Tools";
import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import ImportModel from "@/views/Tools/Components/ImportModel.vue";
import {useSecurityStore} from "@/stores/Security";

export default {
    name: "WorkerTools",
    components: {ImportModel},
    setup() {
        const {mxRules} = useValidation();
        const {$swal} = useTools();
        const securityStore = useSecurityStore();
        const {
            dialog,
            loading,
            tableElevation,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
            inputColor,
            backgroundColor,
            itemColor,
            selectedOne,
        } = useSharedData();
        dialog.value = false;

        const {formatedDate} = useSharedMethod();

        const file = ref(null);
        const autoOrganizationalChart = ref(false);
        const autoResponsible = ref(false);
        const workers = ref([]);
        const logs = ref([]);
        const search = ref(null);
        const logDialog = ref(false);

        const headers = [
            {text: 'Code', value: 'code'},
            {text: 'Nom', value: 'lastName'},
            {text: 'Prenom', value: 'firstName'},
            {text: 'Date Naissance', value: 'birthDay'},
            {text: 'Fonction', value: 'occupationName'},
            {text: 'Organigramme', value: 'organizationalChartName'},
            {text: 'Résponsable Hiérarchique', value: 'responsibleName'},
            {text: 'Date de Recrutement', value: 'realEnterDate'},
            {text: 'Lieu Naissance', value: 'birthPlace'},
            {text: 'Sexe', value: 'sex'},
            {text: 'Situation Familiale', value: 'familySituationName'},
            {text: 'Date Mariage', value: 'weddingDate'},
            {text: 'Téléphone Personnel', value: 'personalPhone'},
            {text: 'Téléphone Professionnel', value: 'professionalPhone'},
            {text: 'Email', value: 'email'},
            {text: 'Société de Déclaration', value: 'companyName'},
            {text: 'Lieux de Travail', value: 'workplaceName'},
            {text: 'Etat Employé', value: 'stateName'},
            {text: 'Date Sortie', value: 'exitDate'},
            {text: 'Motif de Sortie', value: 'leavingCauseName'},
            {text: 'Agence CNAS', value: 'cnasAgencyName'},
            {text: 'Numéro Sécurité Sociale', value: 'nss'},
            {text: 'Numéro Mutelle', value: 'numMutuelle'},
            {text: 'Numéro Carte Shifa', value: 'carteShifaNumber'},
            {text: 'Numéro Compte Banquaire', value: 'numCompte'},
            {text: 'Numéro CCP', value: 'numCcp'},
            {text: 'Prénom Père', value: 'prenomPere'},
            {text: 'Nom Mère', value: 'nomMere'},
            {text: 'Prénom Mère', value: 'prenomMere'},
        ];

        function rowColor(item) {
            if (item.code === selectedOne.value.code) {
                return itemColor.value;
            }
        }

        function itemClick(item) {
            selectedOne.value = item;
        }

        function upload() {
            loading.value = true;
            workers.value = [];
            logs.value = [];
            let formData = new FormData();
            formData.append('file', file.value);
            axios.post(`/tools/getWorkers`, formData, {
                params: {
                    autoOrganizationalChart: autoOrganizationalChart.value,
                    autoResponsible: autoResponsible.value
                }
            }).then(response => {
                workers.value = response.data.elements;
                logs.value = response.data.logs;
                dialog.value = false;
                file.value = null;
                if (logs.value.length > 0)
                    logDialog.value = true;
            }).finally(() => {
                loading.value = false;
            });
        }


        const applyDialog = ref(false);
        const applyLoading = ref(false);
        const updateOption = ref(false);

        function apply() {
            applyLoading.value = true;
            axios.post(`/tools/applyWorkers`, workers.value, {params: {update: updateOption.value}}).then(() => {
                $swal.fire('Très Bien', "Importation des employés terminer", 'success')
                workers.value = [];
            }).finally(() => {
                applyLoading.value = false;
            });
        }

        return {
            securityStore,
            mxRules,
            dialog,
            loading,
            tableElevation,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
            inputColor,
            backgroundColor,
            headers,
            file,
            search,
            workers,
            logs,
            logDialog,
            applyDialog,
            applyLoading,
            updateOption,
            autoResponsible,
            autoOrganizationalChart,
            apply,
            upload,
            formatedDate,
            rowColor,
            itemClick
        }
    }
}
</script>

<style scoped>

</style>